export const navbar = document.querySelector('#navbar');
export const hamburger = document.querySelector('.hamburger');
export const linkContainer = document.querySelector('.link-container');

export const spinner = document.querySelector('.spinner');
export const btnShorten = document.querySelector('.btn-shorten');
export const shortenForm = document.querySelector('.shortening-form');
export const inputField = document.querySelector('#raw-link');
export const shortenResults = document.querySelector('.shorten-result');
export const errorContainer = document.querySelector('.error-message');

export const btnStart = document.querySelectorAll('.btn-start');
export const cards = document.querySelectorAll('.card');
export const cardContainer = document.querySelector('.stats-items');
export const cardLine = document.querySelector('.stats-line');
